import type { BoxProps } from '@frontend/legacy-components';

import { useDxfViewerSession } from '../DxfViewerContext';
import { useDxfLayerPanel } from '../hooks/useDxfLayerPanel';
import type { DrawingModel, DxfViewerSession } from '../session/types';
import { useDxfLoad } from '../session/useSessionState';
import { DxfLayerPanel } from './DxfLayerPanel';

type DxfLayerPanelReadyProps = BoxProps & {
  session: DxfViewerSession;
  model: DrawingModel;
};

const DxfLayerPanelReady = ({
  session,
  model,
  ...props
}: DxfLayerPanelReadyProps) => {
  const panel = useDxfLayerPanel(session, model);
  return <DxfLayerPanel {...panel} {...props} />;
};
DxfLayerPanelReady.displayName = 'DxfLayerPanelReady';

/**
 * Load gate for the layers panel. Pages pass positioning only — they do not
 * branch on `session.load`.
 */
export const DxfLayerPanelHost = (props: BoxProps) => {
  const session = useDxfViewerSession();
  const load = useDxfLoad(session);
  if (load.status !== 'ready') {
    return null;
  }
  return <DxfLayerPanelReady session={session} model={load.model} {...props} />;
};
DxfLayerPanelHost.displayName = 'DxfLayerPanelHost';
